import { useState } from 'react';
import { AvailableBonusesTransactionsStatuses, useUpdateBonusStatus } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { useModalContext } from 'src/hooks/useModalContext';
import classNames from 'classnames';
import { Button } from 'src/components/Buttons/Button';
import { BonusData, BonusModalProps } from '../../types';

type Props = {
  bonusData: BonusData;
};

export const Buttons = ({ bonusData }: Props) => {
  const [selectedStatus, setSelectedStatus] = useState<
    AvailableBonusesTransactionsStatuses | undefined
  >(undefined);

  const { t } = useTranslation();
  const { openModal, closeModal } = useModalContext<BonusModalProps>();
  const { mutateAsync: updateBonusStatus, isPending } = useUpdateBonusStatus({
    onSuccess: closeModal
  });

  const { hasActiveBonus, bonusId } = bonusData;

  const handleBonus = (status: AvailableBonusesTransactionsStatuses) => {
    setSelectedStatus(status);
    updateBonusStatus({ bonus_id: bonusId, status });
  };

  const handleActivateBonus = () => {
    if (hasActiveBonus) {
      openModal('CONFIRM_BONUS_MODAL', {
        props: {
          onCancel: () => {
            openModal('BONUS', {
              props: {
                bonusData
              },
              replace: true
            });
          },
          bonusId: bonusId
        },
        replace: true
      });
      return;
    }
    handleBonus('Activated');
  };

  return (
    <div className="w-full flex flex-wrap gap-2 px-4 412:px-7">
      <Button
        loading={isPending && selectedStatus === 'Activated'}
        label={t('bonusModal.getReward')}
        className={classNames('max-w-full flex-1', hasActiveBonus ? 'min-w-full' : 'min-w-fit')}
        spinOnCenter
        title={t('bonusModal.getReward')}
        onClick={handleActivateBonus}
        disabled={isPending}
      />
      {hasActiveBonus && (
        <Button
          loading={isPending && selectedStatus === 'Queue'}
          label={t('bonusModal.addToQueue')}
          mode="button-secondary"
          className="min-w-fit flex-1 max-w-full"
          spinOnCenter
          title={t('bonusModal.addToQueue')}
          onClick={() => handleBonus('Queue')}
          disabled={isPending}
        />
      )}
      <Button
        loading={isPending && selectedStatus === 'Rejected'}
        label={t('bonusModal.decline')}
        className="min-w-fit flex-1 max-w-full"
        spinOnCenter
        mode="button-secondary"
        title={t('bonusModal.decline')}
        onClick={() => handleBonus('Rejected')}
        disabled={isPending}
      />
    </div>
  );
};
